/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_GuideInputs */

const en_mk_desktop_guide = /** @type {(inputs: Mk_Desktop_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer connection guide`)
};

const id_mk_desktop_guide = /** @type {(inputs: Mk_Desktop_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan menghubungkan komputer`)
};

/**
* | output |
* | --- |
* | "Computer connection guide" |
*
* @param {Mk_Desktop_GuideInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_guide = /** @type {((inputs?: Mk_Desktop_GuideInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_GuideInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_guide(inputs)
	return en_mk_desktop_guide(inputs)
});